module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasItemTagId === true) ? _c('div', [_c('a', {
    staticClass: "tm-tag",
    attrs: {
      "href": '/catalog/' + _vm.ShopTag.path
    }
  }, [_vm._v(_vm._s(_vm.ShopTag.name))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45db2347","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Shop/ShopGroup/ShopTag.vue
// module id = 87
// module chunks = 0